

$(document).ready(function() {
	
	buildDates('#cruises','#cruisetours', '');	
	
	$('input[name=meta]').each(function(){
		if( $(this).val() == defaultMeta ){
			$(this).attr('checked',true );
		}
	});

	    //UI -Dynamic Height for list items
    var activeScreen = '#'+type;
	
	function searchLightAutoSize() {
        if ($('#find-compare').length >= 1) { // Function only for SearchLight Advanced Page
			//var activeScreen = '#cruises';
            var containerHeight = $(activeScreen).outerHeight();
            $('.col1, .col2, .col3, .col4, .col5').css('height', containerHeight); //Adjust height to match the container height
            var columns = [activeScreen + ' .col1', activeScreen + ' .col2', activeScreen + ' .col3'];
            jQuery.each(columns, function(i) {
                var totalColumnHeight = 0;
                $(columns[i] + " > * ").each(function() {
                    var currentElement = $(this);
                    totalColumnHeight += currentElement.outerHeight();
                });
                var currentElement = $(columns[i] + " li");
                var emptySpaceInThisColumn = containerHeight - totalColumnHeight;
				var totalNumberOfListElements = currentElement.length;
                var elementLineHeight = currentElement.css('line-height');
                var extaLineHeightToBeAdded = Math.floor(emptySpaceInThisColumn/totalNumberOfListElements);
                var remainingheight = emptySpaceInThisColumn % totalNumberOfListElements;
                var newLineHeight = Math.floor(parseInt(elementLineHeight.replace('px', ''))) + extaLineHeightToBeAdded;
                if (remainingheight !== 0) {
                    for (var j = 1; j <= remainingheight; j++) {
                        var paddingTop = parseInt($(columns[i] + ' li:eq(' + j + ')').css('padding-top'));
						paddingTop =paddingTop+1;
						$(columns[i] + ' li:eq(' + j + ')').css('padding-top', paddingTop);
                    }				
	           }
                newLineHeight = newLineHeight + "px";
				$(columns[i] + " li").css('line-height', newLineHeight);
				$(columns[i] + " #sub-trade li").removeAttr('style');
            });
            outerContainerHeight = parseInt(containerHeight + 24) + "px"; // height for #find-compare div
            $('#find-compare').css('height', outerContainerHeight); //Adjust the height of container based on the inside content height
        }
    }

    searchLightAutoSize();
	
	$('#cruises,#cruisetours').removeAttr('checked');

	if( resType != 'C' && resType == 'T' ){
		type = "cruisetours";
		$('#cruises').hide()
		$('#cruisetours').show();
		$('#selections span').css('background',tSelectionsColor);
		$('#options span').css('background',tOptionColor); 
		
	}
	$('#'+type+'_input').attr('checked', true); //default checked state.


	
	$('#cruisetours_input').click(function() {
		$('#cruises').fadeOut(300);
		$('#cruisetours').fadeIn(300);
		$('#selections span').css('background',tSelectionsColor);
		$('#options span').css('background',tOptionColor);
		resType = 'T';
		type="cruisetours";
		clearQueryParams();
		$('#'+type+' li').removeClass('selected');
		cruisedBefore( '#cruised-with-princess-tours' )
		$('#ct-banner').slideDown();
		fetchResults( update, type );
	}); 
	$('#cruises_input').click(function() {
		$('#cruisetours').fadeOut(300)
		$('#cruises').fadeIn(300);
		$('#selections span').css('background',cSelectionsColor);
		$('#options span').css('background',cOptionColor);
		resType = 'C';
		type="cruises";
		clearQueryParams();
		$('#'+type+' li').removeClass('selected');
		cruisedBefore( '#cruised-with-princess' )
		fetchResults( update, type  );
		searchLightAutoSize();
	}); 	

	$('div.results').css('cursor','pointer').live('click', function(){
		viewDetails();
		return false;
	});
	
	setClick("cruises");
	setClick("cruisetours");
	getData(update, type);
	
	

	
 }); //Document.Ready Ends
 

 
 function fetchResults( callback, type ){
	clearQueryParams();
	XML_url = getQueryString( resType, engineId );
	getData( callback, type );
}
 
 function update( xml, type ){
 	var choices = $("#"+type+" li");
	
	choices.removeClass('default disabled');
	$(xml).find('cruisedata M').each(function(){ // Highlighting
		theContent = $(this).text();
		$('#'+theContent).addClass('default');
		$('#'+theContent).show();

	});
	
	//Disable those that do not have any cruise				
	choices.not(".default").addClass('disabled'); 
	choices.filter(".selected.disabled").removeClass('selected'); //Can't be "selected" and "disabled"
 }
 
function handleSubtrade( selection, action ){
	selection.parents().eq(2).children().each( function(i) {
		if( $(this).attr('id') == 'MA'){
			switch( action ){
				case 'remove':
					$(this).removeClass('selected');
						return;
				case 'add':
					$(this).addClass('selected');
			}
		}
	});
 
}
 
function clearAll(){ //Clear Button Action
	$('#find-compare li').removeClass();
	clearQueryParams();
	sendQuery( update, type );
} 
 	


